import React, { useEffect, useState } from "react";
import { Card, Button, Form, Col, Collapse, Row, Alert } from "react-bootstrap";
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";
import { deepCopy } from "../../Shared/Utility/DeepCopy";

interface IProps {
    isAdaRequested: boolean
    isNmaRequested: boolean
    isSectionOpen: boolean
    isArticleBased: boolean
    onContinue: (isAdaRequested: boolean, isNmaRequested: boolean) => void;
    onOpen: () => void;
    disabled: boolean;
    isLoading?: boolean;
}

interface ISelection {
    isAdaRequested: boolean;
    isNmaRequested: boolean;
}

export function TestingOptions(props: IProps) {
    const [openCollapse, setOpenCollapse] = useState<boolean>(props.isSectionOpen);
    const [selection, setSelection] = useState<ISelection>({
        isAdaRequested: !props.isArticleBased && props.isAdaRequested,
        isNmaRequested: !props.isArticleBased && props.isNmaRequested
    });

    const [errorMessage, setErrorMessage] = useState<string>("");

    const isNoAccommodationRequested = () => {
        return selection.isAdaRequested === false && selection.isNmaRequested === false;
    }

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (validateSelection()) {
            if (selection.isAdaRequested === null) selection.isAdaRequested = false;
            if (selection.isNmaRequested === null) selection.isNmaRequested = false;

            props.onContinue(selection.isAdaRequested, selection.isNmaRequested);
        }
    }

    const validateSelection = () => {
        if (!selection.isNmaRequested && !selection.isAdaRequested && !isNoAccommodationRequested()) {
            setErrorMessage("You must choose a selection.")
            return false;
        }
        setErrorMessage("");
        return true;
    }
    const toggleAda = () => {
        var updated = deepCopy(selection);
        updated.isAdaRequested = !updated.isAdaRequested;
        setSelection(updated);
    }
    const toggleNma = () => {
        var updated = deepCopy(selection);
        updated.isNmaRequested = !updated.isNmaRequested;
        setSelection(updated);
    }

    const toggleNoAccommodation = () => {
        var updated = deepCopy(selection);
        var noAccommodation = isNoAccommodationRequested();

        updated.isAdaRequested = noAccommodation ? null : false;
        updated.isNmaRequested = noAccommodation ? null : false;
        setSelection(updated);
    }

    useEffect(() => {
        setOpenCollapse(props.isSectionOpen);
    }, [props.isSectionOpen]);

    useEffect(() => {
        if (openCollapse) props.onOpen();
    }, [openCollapse]);

    return (
        <Card className="mb-4" border="pp-secondary-grey">
            <Card.Body>
                <Card.Title className="mb-0 font-weight-bolder" onClick={() => {if (!props.disabled) setOpenCollapse(!openCollapse)}}>
                    <span className={`text-pp-primary ${props.disabled && 'pp-disabled'}`}><i className="font-weight-bolder las la-angle-down"></i> Testing Options</span>
                </Card.Title>
                <Collapse in={openCollapse}>
                    <Row className="mt-3">
                        <Col xs={12} md={8} lg={6} xl={6}>
                            <Form noValidate onSubmit={(e) => onSubmit(e)}>
                                {!props.isArticleBased ?
                                <Form.Group controlId="formTestingOptionsControls">
                                    <Form.Check type="checkbox">
                                        <Form.Group controlId="no-accommodation">
                                            <Form.Check.Input checked={isNoAccommodationRequested()} type="checkbox" onChange={() => toggleNoAccommodation()} />
                                            <Form.Check.Label className="font-weight-bolder mb-1 pp-font-size-smaller">I do not request accommodations.</Form.Check.Label>
                                        </Form.Group>
                                    </Form.Check>
                                    <Form.Check type="checkbox">
                                        <Form.Group controlId="ada-accommodation">
                                            <Form.Check.Input  checked={selection.isAdaRequested} type="checkbox" onChange={() => toggleAda()} />
                                            <Form.Check.Label className="font-weight-bolder mb-1 pp-font-size-smaller">I have a disability and request accommodations during the examination.</Form.Check.Label>
                                            <div className="ml-3">
                                                <small>NOTE: The Board will contact you by email with a link to the application for testing accommodations and submission deadline information.</small>
                                            </div>
                                        </Form.Group>
                                    </Form.Check>
                                    
                                    <Form.Check type="checkbox">
                                        <Form.Group controlId="nma-accommodation">
                                            <Form.Check.Input checked={selection.isNmaRequested} type="checkbox" onChange={() => toggleNma()} />
                                            <Form.Check.Label className="font-weight-bolder mb-1 pp-font-size-smaller"> I am pregnant or a nursing mother and request accommodations.</Form.Check.Label>
                                        </Form.Group>
                                    </Form.Check>
                                </Form.Group>
                                :
                                <p>
                                    Qualifications for test accommodations for applicants with disabilities can be found on the <a href="https://www.abpn.org/about/policies/">ABPN website policies section.</a>  
                                </p>}
                                
                                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                                {props.isLoading ? <AbpnSpinner /> : <Button type="submit" variant="pp-primary">Continue</Button>}
                            </Form>
                        </Col>
                    </Row>
                </Collapse>
            </Card.Body>
        </Card>
    );
}
export default TestingOptions;